module.exports = __webpack_public_path__ + "static/media/rim-back-right.fa648b02.svg";